import React from 'react';
import { GLOBAL_RULE_TABLE_VIEW } from 'Common/enums';

function useRuleView() {
    const [viewOption, setViewOption] = React.useState(GLOBAL_RULE_TABLE_VIEW);

    return {
        viewOption,
        setViewOption
    };
}

export default useRuleView;
